import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { ButtonLink } from "simplydo/react/ui/button";
import { CardContent } from "simplydo/react/ui/card";
import { H3, H4, Subheader } from "simplydo/react/ui/header";
import { Image } from "simplydo/react/ui/image";

import api from "api";
import util from "utils/utils";

import {
  HomeRow,
  HomeRowActions,
  HomeRowContainer,
  HomeRowContent,
  HomeRowIcon,
} from "../HomeUI";
import HomeBlock from "./HomeBlock";

const ExploreChallengesBlock = () => {
  const { t } = useTranslation();

  const challengesQuery = useQuery(initUseQuery(api.users.dashboard, []));

  if (!challengesQuery.data?.challenges?.length) return null;

  return (
    <HomeBlock $width={1}>
      <CardContent>
        <H3>
          Engage in important {t("generic.challenges")}
          <Subheader>
            These {t("generic.challenges")} are highlighted by your
            organisation.
          </Subheader>
        </H3>
        <HomeRowContainer>
          {challengesQuery.data?.challenges?.map((challenge) => (
            <HomeRow key={challenge._id}>
              <HomeRowIcon>
                <Image src={util.challengeImage(challenge)} />
              </HomeRowIcon>
              <HomeRowContent>
                <H4>
                  {challenge.name}
                  <Subheader>{challenge.tagline}</Subheader>
                </H4>
              </HomeRowContent>
              <HomeRowActions>
                <ButtonLink
                  color="primary"
                  variant="outline"
                  size="small"
                  to={`/challenges/${challenge._id}`}
                >
                  Visit {t("generic.challenge")}
                </ButtonLink>
              </HomeRowActions>
            </HomeRow>
          ))}
        </HomeRowContainer>
      </CardContent>
    </HomeBlock>
  );
};

export default ExploreChallengesBlock;
